import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  0% { opacity: 0.6; }
  50% { opacity: 1; }
  100% { opacity: 0.6; }
`;

export const SkeletonBlock = styled.div<{ width?: string; height?: string }>`
  height: ${({ height }) => height ?? "16px"};
  width: ${({ width }) => width ?? "100%"};
  max-width: 100%;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.interfacePure100};
  animation: ${shimmer} 1.2s ease-in-out infinite;
`;

export const SkeletonCircle = styled.div<{ size?: string }>`
  width: ${({ size }) => size ?? "36px"};
  height: ${({ size }) => size ?? "36px"};
  min-width: ${({ size }) => size ?? "36px"};
  min-height: ${({ size }) => size ?? "36px"};
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.interfacePure100};
  animation: ${shimmer} 1.2s ease-in-out infinite;
`;

export const SkeletonBadge = styled.div`
  width: 48px;
  height: 24px;
  border-radius: 20px;
  background: ${({ theme }) => theme.colors.interfacePure100};
  animation: ${shimmer} 1.2s ease-in-out infinite;
`;

export const SkeletonIcon = styled.div`
  width: 20px;
  height: 20px;
  min-width: 20px;
  border-radius: 6px;
  background: ${({ theme }) => theme.colors.interfacePure100};
  animation: ${shimmer} 1.2s ease-in-out infinite;
`;

export const SkeletonTableRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 100px 1fr 80px 100px 90px;
  gap: 12px;
  align-items: center;
  padding: 12px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.interfaceBorder100};
`;
